document.addEventListener("DOMContentLoaded", () => {
  const elements = document.querySelectorAll('.slide-in-left, .slide-in-right');

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('slide-in-active');
      }
    });
  }, {
    threshold: 0.2
  });

  elements.forEach(el => observer.observe(el));
});

document.addEventListener("DOMContentLoaded", () => {
  const drawerDetails = document.querySelector("#Details-menu-drawer-container");

  if (!drawerDetails) return;

  drawerDetails.addEventListener("toggle", () => {
    if (drawerDetails.open) {
      document.body.classList.add("overflow-hidden-desktop");
    } else {
      document.body.classList.remove("overflow-hidden-desktop");
    }
  });
});


// vanilla JS show more/less for HOW IT WORKS section
(function () {
  document.querySelectorAll('.how-it-works-second-sec').forEach(function (card) {

    var content = card.querySelector('.how-it-works-second-scrolable-content');
    var btn = card.querySelector('.show-toggle');
    if (!content || !btn) return;

    var collapsed = parseInt(card.getAttribute('data-collapsed') || '330', 10);

    // initial collapse
    content.style.overflow = 'hidden';

    function collapse() {
      content.style.maxHeight = collapsed + 'px';
      btn.textContent = 'Show More';
      btn.setAttribute('aria-expanded', 'false');
    }

    function expand() {
      content.style.maxHeight = content.scrollHeight + 'px';
      btn.textContent = 'Show Less';
      btn.setAttribute('aria-expanded', 'true');
    }

    // hide button if not needed
    requestAnimationFrame(function () {
      if (content.scrollHeight <= collapsed + 5) {
        btn.style.display = 'none';
      } else {
        collapse();
      }
    });

    btn.addEventListener('click', function () {
      var isCollapsed = btn.getAttribute('aria-expanded') !== 'true';
      isCollapsed ? expand() : collapse();
    });

    // recalc on resize for smooth height adjustment
    window.addEventListener('resize', function () {
      if (btn.getAttribute('aria-expanded') === 'true') {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
})();



$('.testi-slider').slick({ 
    dots: false,
    // vertical:true,
    //  verticalSwiping: true,
    arrows: true,
      centerPadding: '0px',
      centerMode: true,
    prevArrow: jQuery('.testi-slider-left-arrow'),
    nextArrow: jQuery('.testi-slider-right-arrow'),
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  });

document.addEventListener("scroll", function () {
  const floatElement = document.querySelector('.hero-floating-shopnow');
  const floatImg = document.querySelector('.hero-floating-shopnow img'); // main img
  const floatRect = floatElement.getBoundingClientRect();
  const sections = document.querySelectorAll('section[data-theme]');

  let currentTheme = "light";

  sections.forEach(section => {
    const rect = section.getBoundingClientRect();

    if (floatRect.top < rect.bottom && floatRect.bottom > rect.top) {
      currentTheme = section.getAttribute('data-theme');
    }
  });

  // BEFORE + IMG swap
  if (currentTheme === "dark") {
    floatElement.classList.add("dark-icon");

    // IMG change
    floatImg.src = "https://cdn.shopify.com/s/files/1/0794/3972/4787/files/cart-black-icon.png?v=1764251527";
  } else {
    floatElement.classList.remove("dark-icon");

    // IMG change
    floatImg.src = "https://cdn.shopify.com/s/files/1/0794/3972/4787/files/cart-white-icon.png?v=1764251890";
  }
});


